import { handleActions } from 'redux-actions';
import { SET_RECENT_SEARCHES } from './actions';
export const recentSearchesReducer = handleActions({
    [SET_RECENT_SEARCHES]: (state, action) => {
        return action.payload;
    }
}, []);
